import { render, staticRenderFns } from "./LicenseIssue.vue?vue&type=template&id=2b573016&scoped=true&"
import script from "./LicenseIssue.vue?vue&type=script&lang=js&"
export * from "./LicenseIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b573016",
  null
  
)

export default component.exports